var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 159,
    viewBox: "0 0 193 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6441 155.413C74.6441 157.273 61.44 158.779 45.1521 158.779C28.8643 158.779 15.6602 157.263 15.6602 155.413C15.6602 153.562 28.8643 152.046 45.1521 152.046C61.44 152.046 74.6441 153.562 74.6441 155.413Z",
    fill: "#093269"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.014 121.479C119.463 122.004 119.874 122.561 120.242 123.147",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.293 122.945C117.663 123.393 118.001 123.866 118.304 124.361",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.662 122.292L117.842 123.632",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.392 123.378C120.75 123.97 121.066 124.587 121.337 125.223",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.464 124.552C118.765 125.054 119.031 125.576 119.263 126.114",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.891 124.285L118.879 125.321",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.439 125.477C121.699 126.119 121.912 126.78 122.076 127.453",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.345 126.327C119.566 126.869 119.747 127.427 119.886 127.995",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.8 126.451L119.646 127.149",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.144 127.716C122.296 128.393 122.401 129.081 122.457 129.773",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.936 128.216C120.065 128.787 120.152 129.366 120.199 129.95",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.336 128.736L120.102 129.075",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.47 130.04C122.495 130.384 122.5 130.733 122.495 131.051L122.444 132.087",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.21 130.178C120.21 130.471 120.235 130.764 120.21 131.057L120.164 131.937",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.496 131.079L120.237 131.059",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.43 132.388C122.385 132.731 122.329 133.07 122.278 133.399C122.248 133.571 122.228 133.742 122.192 133.904L122.061 134.41",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.177 132.165L120.046 133.035C120.02 133.176 120.005 133.323 119.975 133.464L119.864 133.889",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.28 133.412L120.05 133.033",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.998 134.691C121.922 135.035 121.822 135.373 121.699 135.702C121.578 136.026 121.462 136.355 121.335 136.678",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.813 134.111C119.749 134.397 119.664 134.677 119.56 134.95C119.454 135.223 119.363 135.502 119.252 135.774",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.691 135.689L119.553 134.951",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.217 136.907L120.762 137.842C120.591 138.146 120.409 138.439 120.227 138.732",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.153 135.978L118.769 136.771L118.319 137.524",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.756 137.841L118.765 136.77",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.096 138.965C119.914 139.258 119.692 139.526 119.489 139.804L119.176 140.219L118.827 140.608",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.199 137.721C118.047 137.968 117.855 138.191 117.693 138.428L117.43 138.782L117.137 139.106",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M119.471 139.804L117.676 138.429",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M118.628 140.805C118.403 141.068 118.159 141.317 117.9 141.548C117.643 141.775 117.395 142.018 117.127 142.235",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M116.966 139.273C116.779 139.505 116.573 139.72 116.349 139.915C116.132 140.108 115.919 140.315 115.697 140.502",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.902 141.548L116.35 139.9",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M116.907 142.401L116.073 143.023L115.188 143.564",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M115.515 140.621L114.812 141.147L114.059 141.602",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M116.079 143.022L114.815 141.146",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.959 143.699C114.656 143.871 114.337 144.008 114.029 144.164L113.559 144.387L113.053 144.564",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M113.868 141.725C113.616 141.866 113.363 141.982 113.085 142.114C112.953 142.175 112.822 142.245 112.685 142.301L112.276 142.453",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.035 144.166L113.084 142.113",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112.821 144.661C112.169 144.893 111.502 145.082 110.825 145.227",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M112.052 142.528C111.503 142.734 110.94 142.903 110.369 143.034",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M111.825 144.974L111.219 142.795",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.556 145.272L109.545 145.429C109.207 145.47 108.858 145.47 108.534 145.495",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M110.143 143.049L109.279 143.18C108.986 143.216 108.693 143.216 108.399 143.236",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M109.523 145.43L109.28 143.181",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M108.212 145.505C107.52 145.512 106.828 145.478 106.14 145.404",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.174 143.246C107.881 143.267 107.587 143.267 107.294 143.246C107.001 143.245 106.709 143.223 106.419 143.181",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M107.176 145.485L107.287 143.226",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 145.362C105.543 145.307 105.194 145.266 104.87 145.19L103.859 144.933",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M106.195 143.126C105.907 143.075 105.613 143.05 105.33 142.984L104.481 142.767",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M104.854 145.191L105.33 142.981",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M103.577 144.869C102.92 144.653 102.276 144.394 101.651 144.096",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M104.254 142.711C103.697 142.528 103.154 142.308 102.626 142.054",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M102.605 144.509L103.429 142.406",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M101.389 143.958L100.924 143.73L100.479 143.462C100.186 143.275 99.8772 143.114 99.5991 142.906",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M102.396 141.936L102.001 141.744L101.627 141.516C101.38 141.359 101.122 141.223 100.884 141.046",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M100.501 143.484L101.654 141.538",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3981 142.766C99.1251 142.559 98.842 142.357 98.5741 142.139L97.8057 141.432",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M100.721 140.924C100.488 140.747 100.245 140.58 100.018 140.393L99.3608 139.807",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5728 142.139L100.019 140.4",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M97.611 141.255C97.1264 140.76 96.6754 140.233 96.2612 139.678",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2024 139.657C98.7962 139.236 98.4164 138.79 98.0649 138.322",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9038 140.49L98.6074 139.004",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0994 139.464C95.9983 139.323 95.8871 139.186 95.791 139.045L95.5231 138.6C95.3512 138.297 95.149 138.014 95.0176 137.7",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9227 138.14C97.8367 138.018 97.7457 137.907 97.6648 137.786L97.4374 137.407C97.2958 137.154 97.1189 136.901 96.9976 136.648",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5151 138.6L97.4361 137.407",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8729 137.458C94.7263 137.144 94.5646 136.836 94.4331 136.518L94.0742 135.542",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9028 136.442C96.7815 136.179 96.6399 135.936 96.5287 135.648L96.2305 134.824",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M94.437 136.518L96.5248 135.648",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9849 135.284C93.7865 134.621 93.6328 133.945 93.5249 133.262",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1479 134.612C95.9828 134.051 95.8544 133.481 95.7637 132.903",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7217 134.277L95.9257 133.762",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4848 132.99L93.409 132.484C93.409 132.312 93.409 132.135 93.3736 131.979L93.3281 130.942",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7299 132.676L95.6641 132.241C95.6566 132.095 95.6566 131.948 95.6641 131.801L95.6187 130.927",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3799 131.957L95.6396 131.8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3384 130.652L93.3889 129.616C93.3889 129.267 93.485 128.928 93.5305 128.604",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5981 130.693L95.6436 129.819C95.6436 129.526 95.7245 129.237 95.7599 128.949",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3901 129.618L95.6448 129.82",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5767 128.318C93.6328 127.977 93.7088 127.639 93.8041 127.307C93.8795 126.964 93.9757 126.627 94.0923 126.296",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7949 128.722C95.841 128.433 95.9051 128.148 95.987 127.868C96.0495 127.581 96.1305 127.299 96.2297 127.023",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8047 127.301L95.9936 127.867",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1777 126.053C94.3041 125.73 94.4002 125.396 94.5569 125.083L95.0068 124.147",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M96.334 126.812C96.4401 126.539 96.516 126.251 96.6474 125.993L97.0316 125.199",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5615 125.083L96.6291 125.993",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1313 123.904C95.472 123.302 95.8519 122.722 96.2688 122.17",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1113 124.996C97.4024 124.488 97.7249 123.998 98.0769 123.53",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6704 123.015L97.5712 124.248",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4375 121.953C96.6436 121.674 96.8682 121.408 97.1098 121.159C97.3474 120.912 97.5648 120.654 97.8277 120.411",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M98.21 123.347C98.3851 123.111 98.5759 122.886 98.7812 122.675C98.969 122.451 99.1716 122.24 99.3878 122.043",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1011 121.159L98.7794 122.676",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0234 120.23C98.2863 120.008 98.529 119.75 98.807 119.548L99.636 118.926",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5576 121.891C99.78 121.699 99.9823 121.482 100.22 121.315L100.923 120.81",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M98.811 119.548L100.221 121.317",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8687 118.774C100.447 118.394 101.052 118.056 101.678 117.763",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M101.112 120.659C101.598 120.34 102.104 120.054 102.629 119.805",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 118.231L101.862 120.203",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M101.921 117.672C102.232 117.521 102.553 117.391 102.881 117.283C103.211 117.153 103.549 117.043 103.892 116.954",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M102.854 119.693C103.116 119.568 103.386 119.46 103.663 119.37C103.934 119.258 104.213 119.165 104.497 119.092",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M102.885 117.257L103.663 119.38",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M104.129 116.858C104.468 116.782 104.796 116.671 105.14 116.621L106.151 116.464",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M104.72 119.042C105.003 118.976 105.281 118.88 105.569 118.839L106.438 118.708",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M105.145 116.619L105.569 118.838",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M106.44 116.422C107.132 116.368 107.825 116.35 108.518 116.366",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M106.668 118.682C107.255 118.682 107.836 118.596 108.423 118.632",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M107.477 116.368L107.548 118.628",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M108.783 116.379C109.474 116.42 110.161 116.509 110.84 116.647",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M108.648 118.633C109.233 118.667 109.814 118.745 110.387 118.865",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M109.822 116.479L109.529 118.719",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M111.104 116.7C111.78 116.852 112.444 117.053 113.091 117.302",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M110.618 118.905C111.188 119.035 111.749 119.204 112.296 119.411",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M112.119 116.97L111.467 119.133",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M113.354 117.399C113.997 117.659 114.62 117.965 115.219 118.314",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M112.504 119.496C113.045 119.716 113.57 119.973 114.076 120.264",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M114.303 117.822L113.312 119.854",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M115.448 118.444C116.039 118.807 116.605 119.209 117.141 119.647",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M114.287 120.382C114.786 120.686 115.264 121.024 115.718 121.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M116.317 119.017L115.013 120.867",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M117.355 119.82C117.879 120.271 118.374 120.756 118.836 121.271",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M115.894 121.543C116.34 121.923 116.759 122.333 117.147 122.771",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M118.118 120.522L116.536 122.135",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M113.014 138.135C111.992 138.856 110.829 139.353 109.602 139.591C108.374 139.83 107.11 139.805 105.893 139.518C104.676 139.231 103.533 138.689 102.541 137.928C101.549 137.167 100.73 136.203 100.138 135.102",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M116.435 128.667C116.894 130.406 116.813 132.244 116.202 133.936C115.59 135.627 114.478 137.092 113.012 138.135",
    stroke: "#D5E6FB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M101.538 124.844C102.62 123.712 103.984 122.887 105.49 122.456C106.996 122.026 108.59 122.004 110.108 122.393C111.625 122.782 113.012 123.568 114.125 124.671C115.238 125.773 116.037 127.152 116.44 128.666",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M100.132 135.097C99.2569 133.458 98.9211 131.585 99.1725 129.744C99.4239 127.903 100.25 126.189 101.532 124.845",
    stroke: "#D5E6FB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M149.71 142.038C149.182 142.487 148.623 142.897 148.037 143.266",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M148.235 140.312C147.791 140.694 147.32 141.042 146.824 141.354",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M148.894 142.684L147.55 140.859",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M147.804 143.412C147.208 143.767 146.59 144.083 145.954 144.357",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M146.629 141.476C146.129 141.778 145.609 142.047 145.072 142.279",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M146.892 143.918L145.86 141.906",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M145.701 144.464C145.058 144.722 144.398 144.935 143.725 145.101",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M144.864 142.365C144.323 142.586 143.765 142.765 143.196 142.901",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M144.728 144.819L144.036 142.665",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M143.466 145.161C142.79 145.314 142.104 145.417 141.414 145.469",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M142.966 142.948C142.393 143.076 141.812 143.164 141.227 143.211",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M142.436 145.354L142.098 143.119",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M141.133 145.477C140.789 145.502 140.441 145.507 140.097 145.502L139.061 145.446",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M141.001 143.235C140.708 143.235 140.415 143.26 140.122 143.235L139.247 143.194",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M140.097 145.516L140.117 143.251",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M138.792 145.475L137.781 145.324C137.609 145.293 137.437 145.273 137.275 145.238L136.77 145.106",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M139.012 143.194L138.147 143.068C138.001 143.042 137.854 143.027 137.713 142.997L137.288 142.886",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M137.765 145.299L138.149 143.069",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M136.481 145.015C136.137 144.94 135.799 144.838 135.47 144.711C135.147 144.595 134.818 144.479 134.5 144.353",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M137.07 142.83C136.784 142.765 136.504 142.681 136.231 142.577C135.958 142.471 135.68 142.38 135.412 142.269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M135.495 144.71L136.233 142.577",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M134.272 144.232L133.337 143.782C133.039 143.61 132.746 143.428 132.447 143.246",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M135.202 142.168L134.408 141.789L133.66 141.339",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M133.339 143.781L134.411 141.789",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M132.219 143.105C131.926 142.923 131.658 142.7 131.38 142.498L130.966 142.185L130.582 141.836",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M133.459 141.218C133.212 141.066 132.984 140.874 132.747 140.712L132.398 140.45L132.074 140.151",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M131.379 142.499L132.754 140.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M130.374 141.653C130.112 141.427 129.866 141.184 129.636 140.925C129.404 140.667 129.166 140.419 128.944 140.151",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M131.909 139.991C131.685 139.801 131.475 139.594 131.282 139.374C131.09 139.156 130.882 138.944 130.695 138.722",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M129.638 140.926L131.281 139.374",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M128.779 139.935L128.158 139.1L127.617 138.216",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M130.557 138.535L130.031 137.832L129.576 137.084",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M128.156 139.101L130.026 137.832",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M127.476 137.984C127.304 137.681 127.167 137.362 127.016 137.054C126.94 136.897 126.859 136.74 126.793 136.584L126.611 136.078",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M129.459 136.88C129.318 136.628 129.201 136.375 129.07 136.097C129.009 135.965 128.944 135.834 128.883 135.698L128.736 135.288",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M127.016 137.052L129.063 136.102",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M126.519 135.839C126.284 135.187 126.093 134.52 125.948 133.842",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M128.651 135.077C128.447 134.527 128.278 133.965 128.146 133.394",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M126.207 134.85L128.386 134.243",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M125.911 133.575L125.755 132.564C125.709 132.22 125.709 131.876 125.689 131.527",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M128.136 133.166L127.999 132.296C127.964 132.008 127.969 131.715 127.949 131.422",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M125.751 132.545L127.995 132.297",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M125.652 131.241C125.632 130.904 125.632 130.566 125.652 130.23C125.661 129.883 125.688 129.537 125.733 129.193",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M127.933 131.194C127.912 130.901 127.912 130.607 127.933 130.314C127.937 130.021 127.959 129.729 127.998 129.439",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M125.689 130.203L127.949 130.314",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M125.813 128.898C125.874 128.559 125.91 128.211 125.985 127.887L126.243 126.876",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M128.052 129.212C128.103 128.924 128.128 128.63 128.194 128.347L128.416 127.498",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M125.99 127.874L128.199 128.349",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M126.311 126.605C126.526 125.947 126.783 125.304 127.079 124.679",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M128.477 127.275C128.658 126.719 128.876 126.175 129.129 125.647",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M126.674 125.627L128.782 126.451",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M127.202 124.431L127.435 123.966L127.703 123.521C127.885 123.228 128.051 122.92 128.254 122.642",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M129.224 125.441L129.411 125.047L129.643 124.673C129.8 124.425 129.931 124.167 130.108 123.93",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M127.7 123.521L129.646 124.673",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M128.415 122.422C128.627 122.149 128.825 121.866 129.047 121.598L129.745 120.83",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M130.25 123.737C130.426 123.505 130.593 123.262 130.78 123.035L131.372 122.388",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M129.047 121.601L130.781 123.046",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M129.928 120.628C130.425 120.146 130.952 119.695 131.505 119.278",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M131.525 122.222C131.946 121.816 132.392 121.436 132.859 121.085",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M130.695 119.932L132.176 121.635",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M131.722 119.116C131.858 119.015 131.995 118.904 132.141 118.808L132.586 118.54C132.884 118.368 133.167 118.166 133.481 118.034",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M133.048 120.948C133.165 120.862 133.281 120.771 133.402 120.69L133.776 120.462C134.021 120.303 134.275 120.156 134.535 120.022",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M132.582 118.54L133.77 120.461",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M133.743 117.897C134.061 117.751 134.364 117.589 134.688 117.458L135.664 117.099",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M134.749 119.922C135.011 119.801 135.254 119.659 135.542 119.548L136.366 119.25",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M134.666 117.459L135.53 119.547",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M135.899 117.01C136.562 116.811 137.237 116.658 137.921 116.55",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M136.562 119.188C137.125 119.022 137.697 118.894 138.276 118.804",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M136.904 116.746L137.425 118.95",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M138.189 116.509L138.695 116.434C138.867 116.434 139.039 116.434 139.2 116.398L140.237 116.348",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M138.511 118.749L138.941 118.683C139.088 118.683 139.234 118.683 139.381 118.653L140.26 118.612",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M139.216 116.396L139.373 118.651",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M140.532 116.363L141.569 116.414C141.912 116.414 142.256 116.51 142.58 116.555",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M140.48 118.623L141.36 118.669C141.653 118.669 141.936 118.749 142.23 118.785",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M141.564 116.412L141.361 118.667",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M142.844 116.594C143.185 116.649 143.523 116.725 143.855 116.821C144.198 116.896 144.535 116.992 144.866 117.109",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M142.46 118.819C142.749 118.866 143.034 118.931 143.315 119.011C143.599 119.075 143.88 119.156 144.154 119.254",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M143.882 116.821L143.321 119.01",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M145.135 117.202C145.458 117.329 145.792 117.425 146.1 117.581L147.041 118.031",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M144.357 119.335C144.63 119.441 144.913 119.517 145.176 119.648L145.964 120.033",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M146.091 117.581L145.187 119.649",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M147.27 118.177C147.873 118.516 148.452 118.896 149.004 119.314",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M146.182 120.134C146.692 120.422 147.182 120.744 147.648 121.099",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M148.166 118.692L146.938 120.593",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M149.229 119.457C149.508 119.663 149.773 119.888 150.023 120.129C150.285 120.354 150.535 120.594 150.771 120.847",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M147.84 121.234C148.295 121.602 148.729 121.995 149.139 122.412",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M150.02 120.128L148.503 121.806",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M150.929 121.048C151.156 121.311 151.409 121.553 151.611 121.831L152.233 122.66",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M149.291 122.58C149.478 122.803 149.695 123.005 149.867 123.242L150.373 123.945",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M151.636 121.831L149.872 123.241",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M152.401 122.888C152.781 123.466 153.119 124.071 153.412 124.697",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M150.514 124.137C150.834 124.622 151.119 125.129 151.368 125.653",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M152.947 123.774L150.98 124.887",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M153.541 124.945C153.689 125.258 153.819 125.578 153.93 125.906C154.058 126.228 154.166 126.557 154.254 126.892",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M151.478 125.876C151.605 126.138 151.715 126.408 151.807 126.685C151.914 126.958 152.007 127.236 152.085 127.519",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M153.922 125.907L151.799 126.686",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M154.318 127.156C154.399 127.495 154.505 127.824 154.561 128.167L154.718 129.178",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M152.142 127.742C152.207 128.025 152.303 128.303 152.344 128.591L152.48 129.461",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M154.563 128.167L152.338 128.592",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M154.754 129.46C154.779 130.153 154.855 130.845 154.815 131.538",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M152.504 129.688C152.504 130.274 152.595 130.855 152.555 131.442",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M154.816 130.496L152.556 130.567",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M154.809 131.826C154.764 132.517 154.673 133.205 154.536 133.884",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M152.545 131.676C152.51 132.26 152.434 132.841 152.318 133.415",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M154.707 132.837L152.463 132.549",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M154.464 134.132C154.312 134.808 154.111 135.472 153.862 136.119",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M152.274 133.635C152.146 134.206 151.977 134.767 151.769 135.313",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M154.217 135.136L152.048 134.484",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M153.782 136.376C153.518 137.017 153.212 137.64 152.867 138.241",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M151.692 135.531C151.47 136.072 151.211 136.597 150.918 137.103",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M153.355 137.32L151.323 136.329",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M152.728 138.473C152.366 139.063 151.966 139.628 151.53 140.166",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M150.8 137.307C150.496 137.806 150.158 138.284 149.789 138.737",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M152.163 139.343L150.317 138.034",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M151.359 140.375C150.907 140.902 150.421 141.399 149.903 141.861",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M149.638 138.902C149.252 139.349 148.838 139.771 148.4 140.166",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M150.66 141.143L149.042 139.561",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M133.039 136.033C132.318 135.011 131.821 133.849 131.583 132.621C131.344 131.393 131.369 130.129 131.656 128.912C131.943 127.695 132.485 126.552 133.246 125.56C134.008 124.568 134.971 123.749 136.073 123.157",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M142.522 139.459C140.782 139.918 138.942 139.837 137.25 139.224C135.557 138.612 134.092 137.498 133.048 136.031",
    stroke: "#D5E6FB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M146.329 124.557C147.462 125.638 148.286 127.002 148.717 128.508C149.149 130.014 149.171 131.608 148.782 133.125C148.394 134.643 147.608 136.029 146.506 137.142C145.404 138.256 144.026 139.055 142.512 139.459",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M136.085 123.157C137.724 122.282 139.597 121.946 141.438 122.197C143.279 122.449 144.993 123.275 146.337 124.557",
    stroke: "#D5E6FB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M158.044 132.074C157.996 131.382 157.996 130.688 158.044 129.996",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M160.3 131.898C160.257 131.314 160.257 130.727 160.3 130.144",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M157.998 131.038L160.263 131.018",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M158.05 129.729C158.11 129.039 158.216 128.353 158.368 127.677",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M160.299 129.911C160.348 129.327 160.438 128.748 160.567 128.177",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M158.164 128.698L160.398 129.042",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M158.434 127.412C158.596 126.738 158.811 126.077 159.076 125.436",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M160.621 127.954C160.758 127.387 160.939 126.831 161.162 126.291",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M158.713 126.412L160.862 127.115",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M159.18 125.184C159.453 124.548 159.772 123.933 160.135 123.344",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M161.253 126.078C161.484 125.539 161.754 125.019 162.062 124.521",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M159.625 124.248L161.632 125.284",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M160.278 123.11C160.46 122.817 160.657 122.534 160.87 122.256L161.517 121.447",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M162.186 124.324C162.342 124.077 162.509 123.819 162.691 123.601L163.242 122.919",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M160.869 122.256L162.684 123.601",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M161.688 121.24C161.926 120.987 162.194 120.734 162.416 120.496C162.537 120.375 162.654 120.244 162.785 120.127L163.184 119.799",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M163.378 122.728L163.99 122.101C164.096 121.995 164.192 121.889 164.303 121.788L164.642 121.51",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M162.414 120.496L163.991 122.114",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M163.388 119.624C163.651 119.398 163.928 119.189 164.217 118.997C164.505 118.805 164.788 118.608 165.082 118.421",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M164.818 121.377C165.037 121.191 165.271 121.022 165.516 120.872C165.759 120.71 165.996 120.538 166.244 120.366",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M164.217 118.996L165.516 120.851",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M165.316 118.294L166.236 117.788C166.549 117.647 166.873 117.52 167.191 117.384",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M166.446 120.254L167.219 119.835L168.028 119.496",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M166.239 117.799L167.219 119.836",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M167.441 117.286C167.764 117.16 168.098 117.074 168.427 116.963L168.932 116.811L169.438 116.705",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M168.239 119.405C168.512 119.294 168.8 119.228 169.078 119.132L169.493 119.001L169.928 118.915",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M168.426 116.964L169.073 119.133",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M169.701 116.659C170.034 116.58 170.371 116.522 170.712 116.487C171.055 116.452 171.399 116.406 171.723 116.381",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M170.136 118.87C170.42 118.799 170.709 118.75 171.001 118.724C171.294 118.693 171.582 118.653 171.875 118.633",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M170.727 116.479L171.015 118.724",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M172.033 116.373L173.074 116.357L174.11 116.438",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M172.116 118.627L172.995 118.617L173.87 118.688",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M173.073 116.357L172.997 118.617",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M174.375 116.464C174.719 116.504 175.058 116.575 175.387 116.636L175.892 116.732L176.398 116.873",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M174.096 118.683C174.389 118.718 174.672 118.784 174.96 118.834C175.107 118.86 175.253 118.88 175.395 118.91L175.814 119.031",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M175.396 116.635L174.956 118.854",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M176.667 116.943C177.331 117.139 177.983 117.377 178.618 117.656",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M176.034 119.117C176.595 119.281 177.146 119.481 177.682 119.714",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M177.652 117.272L176.863 119.391",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M178.864 117.778L179.789 118.284C180.092 118.451 180.37 118.653 180.663 118.84",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89 119.82L178.668 120.22C178.926 120.361 179.174 120.538 179.411 120.695",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M179.789 118.257L178.667 120.218",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M180.896 118.96C181.46 119.361 182 119.795 182.513 120.259",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M179.6 120.815C179.843 120.968 180.076 121.137 180.297 121.321C180.533 121.498 180.757 121.688 180.97 121.892",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M181.715 119.587L180.294 121.346",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M182.699 120.447C182.942 120.695 183.205 120.928 183.432 121.19L184.094 121.989",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M181.134 122.079C181.336 122.286 181.558 122.478 181.751 122.701L182.312 123.378",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M183.429 121.19L181.746 122.702",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M184.295 122.222C184.701 122.784 185.071 123.372 185.402 123.981",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M182.46 123.552C182.8 124.029 183.112 124.525 183.396 125.038",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M184.849 123.06L182.948 124.278",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M185.508 124.191L185.75 124.651L185.953 125.132C186.079 125.45 186.236 125.764 186.337 126.092",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M183.497 125.254L183.704 125.638L183.876 126.043C183.982 126.315 184.114 126.578 184.2 126.856",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M185.953 125.132L183.881 126.027",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M186.42 126.355C186.522 126.684 186.633 127.013 186.724 127.367L186.936 128.378",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M184.295 127.062C184.376 127.341 184.472 127.619 184.548 127.902L184.73 128.761",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M186.717 127.348L184.523 127.904",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M186.99 128.631C187.089 129.316 187.144 130.006 187.157 130.698",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M184.751 128.985C184.835 129.567 184.88 130.152 184.888 130.74",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M187.099 129.662L184.845 129.859",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M187.158 130.971C187.158 131.143 187.158 131.314 187.158 131.476L187.112 131.982C187.077 132.325 187.077 132.674 187.011 132.993",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M184.898 130.966C184.898 131.112 184.898 131.259 184.898 131.406L184.858 131.84C184.845 132.133 184.816 132.425 184.772 132.715",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M187.11 132.008L184.855 131.841",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M186.963 133.308C186.897 133.646 186.851 133.99 186.771 134.319L186.482 135.33",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M184.731 132.942C184.675 133.225 184.635 133.519 184.569 133.802L184.326 134.646",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M186.774 134.328L184.575 133.803",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M186.41 135.586C186.179 136.24 185.905 136.878 185.591 137.497",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M184.293 134.86C184.096 135.41 183.864 135.947 183.601 136.468",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M186.031 136.559L183.943 135.685",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M185.47 137.742L185.233 138.202C185.147 138.354 185.046 138.495 184.955 138.642L184.389 139.512",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M183.469 136.685L183.272 137.074C183.196 137.2 183.11 137.322 183.034 137.443L182.554 138.181",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M184.947 138.639L183.031 137.441",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M184.209 139.717L183.557 140.526C183.34 140.799 183.082 141.031 182.844 141.279",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M182.406 138.358L181.855 139.041C181.673 139.273 181.45 139.465 181.248 139.678",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M183.563 140.526L181.859 139.04",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M182.658 141.471C182.415 141.717 182.155 141.947 181.88 142.158C181.62 142.386 181.346 142.599 181.061 142.795",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M181.094 139.838C180.887 140.046 180.666 140.24 180.432 140.419C180.215 140.615 179.986 140.796 179.745 140.96",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M181.875 142.158L180.429 140.419",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M180.835 142.948C180.547 143.135 180.269 143.353 179.965 143.514L179.05 144.02",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M179.551 141.087C179.304 141.244 179.076 141.426 178.818 141.562L178.045 141.977",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M179.965 143.513L178.822 141.562",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M178.804 144.124C178.175 144.414 177.526 144.66 176.863 144.862",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M177.838 142.082C177.306 142.324 176.758 142.532 176.2 142.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M177.843 144.53L177.029 142.422",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M176.594 144.969C176.263 145.075 175.926 145.157 175.583 145.216C175.25 145.297 174.913 145.357 174.572 145.398",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M175.975 142.771C175.698 142.861 175.414 142.93 175.126 142.979C174.841 143.049 174.553 143.101 174.262 143.135",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M175.597 145.193L175.132 142.979",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M174.303 145.404C173.959 145.452 173.613 145.483 173.266 145.495H172.23",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M174.036 143.16C173.743 143.16 173.455 143.241 173.161 143.241H172.282",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M173.269 145.495L173.163 143.24",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M171.96 145.505C171.268 145.47 170.578 145.387 169.897 145.257",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M172.057 143.245C171.471 143.214 170.889 143.145 170.312 143.038",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M170.924 145.42L171.182 143.176",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M169.635 145.212C168.959 145.063 168.292 144.874 167.638 144.646",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M170.083 142.998C169.511 142.872 168.948 142.714 168.395 142.522",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M168.623 144.958L169.239 142.784",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M167.383 144.55C167.065 144.414 166.731 144.308 166.423 144.151L165.503 143.676",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M168.184 142.442C167.916 142.326 167.633 142.24 167.375 142.109L166.591 141.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M166.415 144.151L167.376 142.104",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M165.257 143.548C164.681 143.164 164.079 142.815 163.543 142.375",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M166.394 141.593C165.913 141.264 165.383 140.976 164.943 140.582",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M164.383 142.984L165.657 141.113",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M163.329 142.21C162.791 141.769 162.284 141.291 161.812 140.779",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M164.766 140.461C164.312 140.09 163.886 139.686 163.492 139.253",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M162.548 141.523L164.105 139.88",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M161.641 140.582C161.183 140.061 160.762 139.509 160.382 138.929",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M163.33 139.086C162.945 138.645 162.59 138.179 162.269 137.69",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M160.983 139.777L162.778 138.402",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M160.233 138.701C159.87 138.111 159.546 137.498 159.263 136.866",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M162.144 137.498C161.836 137.001 161.562 136.482 161.325 135.946",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M159.719 137.8L161.716 136.733",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M159.153 136.62C158.885 135.981 158.662 135.323 158.485 134.653",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M161.233 135.738C161.008 135.198 160.821 134.642 160.672 134.075",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M158.786 135.648L160.924 134.915",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M158.42 134.389C158.255 133.716 158.139 133.032 158.071 132.342",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M160.613 133.847C160.477 133.278 160.379 132.7 160.32 132.118",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M158.206 133.373L160.435 132.994",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M172.665 122.116C173.916 122.13 175.149 122.41 176.283 122.938C177.417 123.465 178.425 124.228 179.242 125.175C180.059 126.122 180.664 127.232 181.019 128.431C181.374 129.631 181.469 130.892 181.299 132.131",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M164.352 127.783C164.995 126.103 166.136 124.66 167.622 123.647C169.108 122.634 170.869 122.1 172.668 122.117",
    stroke: "#D5E6FB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M174.187 139.609C172.646 139.892 171.058 139.76 169.586 139.226C168.114 138.693 166.81 137.776 165.809 136.572C164.808 135.368 164.145 133.918 163.89 132.373C163.634 130.828 163.794 129.243 164.354 127.78",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M181.317 132.129C181.066 133.969 180.241 135.683 178.96 137.026C177.678 138.37 176.005 139.274 174.179 139.611",
    stroke: "#D5E6FB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M87.855 91.5713H96.8381",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M87.855 93.5928H96.8381",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M87.855 95.6113H96.8381",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1533 104.143L105.568 92.112L110.891 104.143L116.568 83.9327L122.63 104.143L128.59 98.4209L134.373 104.143L140.105 93.7802L145.221 104.143L151.616 98.4209L157.849 104.143L163.127 76.7695L169.587 104.143L175.664 98.4209L181.325 104.143",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M181.325 101.934L175.664 88.5682L169.587 88.7704L163.127 66.9219L157.849 73.2004L151.616 88.5682L145.221 89.1445L140.105 80.6063L134.373 94.2957L128.59 96.9901L122.63 90.4589L116.568 78.6499L110.891 85.7373L105.568 83.4776L99.1533 101.934",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0601 106.586V108.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M110.794 106.586V108.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M122.538 106.586V108.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M134.271 106.586V108.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M146.005 106.586V108.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M157.75 106.586V108.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M169.483 106.586V108.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M181.227 106.586V108.704",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M96.479 106.586H184.005",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M154.747 67.7812C154.49 67.7758 154.241 67.6923 154.033 67.5419C153.825 67.3915 153.668 67.1812 153.582 66.9391C153.496 66.697 153.487 66.4346 153.554 66.1868C153.621 65.9389 153.762 65.7175 153.958 65.5518C158.756 61.5396 162.342 56.2714 164.315 50.3369C166.288 44.4024 166.57 38.0359 165.13 31.95C165.053 31.6235 165.109 31.2798 165.285 30.9945C165.462 30.7091 165.744 30.5055 166.071 30.4284C166.397 30.3513 166.741 30.4071 167.026 30.5834C167.312 30.7597 167.515 31.0422 167.592 31.3687C168.237 34.109 168.563 36.9147 168.563 39.7299C168.568 45.0258 167.408 50.2579 165.164 55.055C162.921 59.8522 159.649 64.0969 155.581 67.488C155.348 67.6838 155.051 67.788 154.747 67.7812Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M132.37 67.4636C147.686 67.4636 160.102 55.0472 160.102 39.7308C160.102 24.4144 147.686 11.998 132.37 11.998C117.053 11.998 104.637 24.4144 104.637 39.7308C104.637 55.0472 117.053 67.4636 132.37 67.4636Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M132.367 19.3213C128.331 19.3203 124.385 20.5163 121.028 22.7582C117.671 25 115.055 28.1869 113.509 31.9159C111.964 35.6448 111.559 39.7483 112.346 43.7074C113.133 47.6664 115.076 51.3032 117.93 54.1578C120.784 57.0124 124.42 58.9566 128.379 59.7444C132.338 60.5323 136.442 60.1284 140.171 58.5839C143.9 57.0395 147.088 54.4237 149.331 51.0676C151.573 47.7114 152.77 43.7656 152.77 39.7291C152.77 34.3175 150.621 29.1274 146.795 25.3004C142.969 21.4733 137.779 19.3226 132.367 19.3213ZM132.367 54.7076C129.401 54.7036 126.502 53.8201 124.038 52.1686C121.574 50.5172 119.654 48.1722 118.523 45.43C117.391 42.6878 117.098 39.6716 117.681 36.7629C118.264 33.8543 119.696 31.1837 121.796 29.0889C123.897 26.9941 126.571 25.5692 129.481 24.9944C132.392 24.4196 135.407 24.7207 138.146 25.8596C140.885 26.9985 143.225 28.9241 144.87 31.3928C146.515 33.8616 147.39 36.7626 147.386 39.7291C147.386 41.7005 146.998 43.6525 146.243 45.4735C145.488 47.2946 144.381 48.9489 142.986 50.342C141.591 51.735 139.936 52.8394 138.113 53.5919C136.291 54.3445 134.339 54.7305 132.367 54.7279V54.7076Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M135.206 39.7297C135.206 40.2918 135.039 40.8413 134.727 41.3086C134.414 41.7759 133.97 42.1401 133.451 42.3549C132.932 42.5698 132.36 42.6258 131.809 42.5157C131.258 42.4057 130.751 42.1346 130.354 41.7368C129.957 41.339 129.687 40.8323 129.578 40.2808C129.469 39.7294 129.526 39.158 129.742 38.639C129.957 38.1199 130.322 37.6766 130.79 37.365C131.258 37.0534 131.808 36.8877 132.37 36.8887C133.123 36.89 133.844 37.1899 134.376 37.7226C134.907 38.2552 135.206 38.9771 135.206 39.7297Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M154.754 29.5963L174.757 24.1367",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M116.955 53.9004L106.542 63.3182H94.3232",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M124.036 18.5638L118.166 2.80176H111.094",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5571 0.780273H106.54",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5571 2.80176H106.54",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5571 4.8252H106.54",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3232 65.7637H103.311",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3232 67.7822H103.311",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3232 69.8037H103.311",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M177.185 19.1016H186.168",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M177.185 21.1172H186.168",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M177.185 23.1387H186.168",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M177.185 47.0703H186.168",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M177.185 49.0889H186.168",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M177.185 51.1094H186.168",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M132.375 12.9238V14.9661",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M125.43 13.8379L125.96 15.8094",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M118.962 16.5176L119.983 18.2818",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M113.416 20.7725L114.857 22.2182",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 26.3281L110.926 27.3442",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M106.471 32.7939L108.443 33.3197",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M105.559 39.7314H107.596",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M106.471 46.6654L108.443 46.1396",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 53.1313L110.926 52.1152",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M113.416 58.687L114.857 57.2412",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M118.962 62.944L119.983 61.1797",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M125.43 65.6239L125.96 63.6523",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M132.375 66.5394V64.4971",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M139.307 65.6239L138.781 63.6523",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M145.772 62.944L144.751 61.1797",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M151.323 58.687L149.882 57.2412",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M153.811 52.1152L167.389 59.9508H176.665",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M158.259 46.6654L156.288 46.1396",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M159.175 39.7314H157.138",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M158.259 32.7939L156.288 33.3197",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M155.58 26.3281L153.811 27.3442",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M151.323 20.7725L149.882 22.2182",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M145.772 16.5176L144.751 18.2818",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M139.307 13.8379L138.781 15.8094",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3618 33.5283H94.5126V27.2902H88.6233L88.0218 25.7686H84.3618V33.5283Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3618 43.6144H94.5126V37.3763H88.6233L88.0218 35.8496H84.3618V43.6144Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3618 53.6923H94.5126V47.4542H88.6233L88.0218 45.9326H84.3618V53.6923Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M108.785 74.1409C108.785 74.3749 108.716 74.6036 108.586 74.7981C108.456 74.9926 108.271 75.1443 108.055 75.2338C107.839 75.3233 107.601 75.3468 107.372 75.3011C107.142 75.2555 106.931 75.1428 106.766 74.9774C106.6 74.8119 106.488 74.6012 106.442 74.3717C106.397 74.1422 106.42 73.9044 106.509 73.6882C106.599 73.4721 106.751 73.2873 106.945 73.1574C107.14 73.0274 107.368 72.958 107.602 72.958C107.916 72.9593 108.216 73.0844 108.437 73.3059C108.659 73.5275 108.784 73.8276 108.785 74.1409Z",
    fill: "#D5E6FB"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M113.293 75.3238C113.947 75.3238 114.476 74.7942 114.476 74.1409C114.476 73.4876 113.947 72.958 113.293 72.958C112.64 72.958 112.11 73.4876 112.11 74.1409C112.11 74.7942 112.64 75.3238 113.293 75.3238Z",
    fill: "#D5E6FB"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M118.994 75.3238C119.647 75.3238 120.177 74.7942 120.177 74.1409C120.177 73.4876 119.647 72.958 118.994 72.958C118.341 72.958 117.811 73.4876 117.811 74.1409C117.811 74.7942 118.341 75.3238 118.994 75.3238Z",
    fill: "#D5E6FB"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M124.685 75.3238C125.338 75.3238 125.868 74.7942 125.868 74.1409C125.868 73.4876 125.338 72.958 124.685 72.958C124.032 72.958 123.502 73.4876 123.502 74.1409C123.502 74.7942 124.032 75.3238 124.685 75.3238Z",
    fill: "#D5E6FB"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8569 116.454H4.45312L6.98578 113.123H82.5811L85.8569 116.454Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8662 113.578C51.9814 113.216 51.1247 112.788 50.3032 112.299C50.3032 112.299 55.0399 88.7722 55.2169 81.0428C55.3938 73.3134 56.4453 57.334 56.4453 57.334H35.2388C35.2388 57.334 36.2902 73.3185 36.4672 81.0428C36.6441 88.7672 40.3799 112.299 40.3799 112.299C39.5591 112.79 38.7023 113.217 37.8169 113.578C36.6795 114.008 35.259 114.589 35.9667 114.862C36.9319 115.172 37.9531 115.269 38.9594 115.145C40.4454 114.75 41.878 114.176 43.226 113.436C43.7921 113.012 44.5555 67.1663 44.5555 67.1663H46.072C46.072 67.1663 46.8708 113.012 47.4369 113.436C48.7863 114.177 50.2207 114.751 51.7086 115.145C52.7132 115.269 53.7327 115.172 54.6962 114.862C55.3938 114.574 53.9885 114.008 52.8662 113.578Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7873 27.6494L36.1094 33.4427V58.208H53.3223V33.2657L47.8324 27.7808L42.7873 27.6494Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8834 33.756L45.1899 32.9775L43.9059 33.5842L44.9725 37.047L43.1577 55.4782L44.8765 57.3334L46.8834 55.4024L45.655 37.047L46.8834 33.756Z",
    fill: "#F26531"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7133 32.1895L22.9761 45.7728L30.2404 46.6069L33.8093 43.3867L33.7133 32.1895Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6869 27.4971L33.7148 32.1883V89.1552H42.248V27.7802L41.6869 27.4971Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3722 32.1895L67.256 44.3725L59.9917 45.2066L56.3115 43.3867L56.3722 32.1895Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3936 27.4971L56.3707 32.1883V89.1552H47.8325V27.7802L48.3936 27.4971Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2381 32.9777L41.4062 34.7218V29.707H48.9284V34.7218L45.2381 32.9777Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M48.926 29.7077L45.1902 32.9784L41.5303 29.7077V20.9824H48.926V29.7077Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4165 26.6088L44.0705 29.6824H46.4818L48.9285 26.9778L48.696 24.4149L41.5328 24.0762L41.4165 26.6088Z",
    fill: "#D5E6FB"
  }))), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7313 18.6662C40.7313 18.6662 39.3614 18.3073 39.4978 19.2678C39.6343 20.2283 40.0489 22.0128 40.7364 22.4273L41.4188 22.8368L40.7313 18.6662Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9194 18.6662C49.9194 18.6662 51.2894 18.3073 51.1529 19.2678C51.0164 20.2283 50.6019 22.0128 49.9194 22.4273L49.2319 22.8368L49.9194 18.6662Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5647 17.0732C50.5686 16.3176 50.4084 15.5702 50.0951 14.8826C49.7817 14.1951 49.3228 13.5838 48.7499 13.091C48.1771 12.5983 47.5041 12.2359 46.7774 12.0288C46.0508 11.8217 45.2878 11.775 44.5413 11.8918C43.7948 12.0086 43.0825 12.2862 42.4539 12.7054C41.8252 13.1245 41.295 13.6752 40.9001 14.3194C40.5052 14.9636 40.2549 15.6858 40.1666 16.4363C40.0783 17.1867 40.154 17.9473 40.3886 18.6656L41.7131 24.9087L44.1396 28.3109H46.4801L48.8308 25.3485L50.2664 18.8122C50.464 18.2537 50.5648 17.6656 50.5647 17.0732Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4214 18.1115C41.4214 18.1115 42.2606 17.2015 43.0138 17.5048C43.767 17.8082 43.4738 18.7181 45.6678 18.9456C46.9011 19.0954 48.1524 18.9641 49.3277 18.5614L49.444 16.6606L41.4062 15.5586L41.4214 18.1115Z",
    fill: "#D5E6FB"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4356 16.6591C49.1443 17.3129 48.9599 18.0093 48.8896 18.7216C49.0059 19.5713 49.2372 20.4012 49.5772 21.1885C49.5772 21.1885 51.2201 17.7611 51.0937 16.5226C50.9673 15.2841 49.3193 16.2496 49.4356 16.6591Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7978 20.9159C40.7978 20.9159 40.7978 20.7036 40.8332 20.38C40.909 19.4954 41.1163 17.7867 41.6218 17.4834C42.3093 17.0739 42.2386 14.9103 42.2386 14.9103C42.2386 14.9103 41.2781 15.9921 44.5741 17.0891C47.87 18.1861 50.5442 17.7614 52.3287 15.4259C54.1132 13.0904 52.4652 11.4475 52.1872 12.2715C51.9091 13.0955 51.3632 14.1925 50.4027 13.3685C49.4422 12.5445 47.9358 10.8965 45.1908 10.8965C42.4458 10.8965 41.2124 13.3685 41.2124 13.3685C40.7716 13.5823 40.3975 13.9123 40.1303 14.323C39.863 14.7336 39.7128 15.2093 39.6958 15.6989C39.7211 17.3469 40.7978 20.9159 40.7978 20.9159Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4525 16.5696C48.5113 16.6454 46.8582 15.3361 45.1698 14.1835C43.4813 13.0309 42.3389 14.1835 42.3389 14.1835C42.4699 13.5564 42.8038 12.9898 43.289 12.5713C43.7741 12.1529 44.3836 11.9058 45.0232 11.8682C47.3182 11.7216 48.0563 14.871 50.1997 15.1491",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M44.975 20.8008H40.3799L40.8854 22.3173C40.9303 22.4624 41.0201 22.5895 41.1418 22.6804C41.2635 22.7712 41.4109 22.8211 41.5628 22.8229H43.9337C44.0921 22.8219 44.2457 22.7682 44.3702 22.6703C44.4947 22.5723 44.583 22.4357 44.6212 22.282L44.975 20.8008Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0696 20.8008H45.4795L45.985 22.3173C46.0283 22.4624 46.1169 22.5898 46.2379 22.6808C46.3589 22.7718 46.506 22.8216 46.6574 22.8229H49.0282C49.1875 22.823 49.3423 22.7699 49.4678 22.6718C49.5933 22.5738 49.6824 22.4365 49.7208 22.282L50.0696 20.8008Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3793 20.799L40.1519 18.5596",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M50.061 20.799L50.5868 18.6758",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9717 20.8008H45.4721",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8472 21.5186H45.6611",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1824 24.4131C46.1824 24.4131 45.8336 24.9186 45.4292 24.9186C45.0248 24.9186 44.6709 24.4131 44.6709 24.4131",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5543 27.502L42.3378 34.8017L42.257 51.2158L37.7578 35.7571L40.336 34.5893L37.5708 33.366L40.0883 28.2147L41.5543 27.502Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9751 27.502L47.8428 34.2911L47.8832 51.4534L52.7766 35.7571L50.1985 34.5893L52.9586 33.366L50.4411 28.2147L48.9751 27.502Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3472 46.4242L37.4864 44.5791V46.313L34.3472 46.4242Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7359 42.8557C49.7359 42.8557 48.5429 41.0156 48.1132 41.0156C47.6835 41.0156 46.7028 42.6383 46.9202 43.1843C47.1376 43.7303 48.3306 42.426 48.3306 42.426L49.195 44.807L49.7359 42.8557Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3226 43.3867L47.6999 43.4979C47.2442 43.8155 46.728 44.0357 46.1834 44.145C45.4251 44.2562 44.9903 44.4736 45.6425 45.0145C46.2946 45.5554 47.6999 44.691 47.6999 44.691L49.3226 45.338C49.4545 45.212 49.5594 45.0606 49.6311 44.8929C49.7027 44.7252 49.7397 44.5447 49.7397 44.3624C49.7397 44.18 49.7027 43.9995 49.6311 43.8318C49.5594 43.6642 49.4545 43.5127 49.3226 43.3867Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9473 46.6365C50.3228 47.0112 50.815 47.2466 51.3425 47.3037C52.2019 47.3846 53.9914 46.0602 53.9914 46.0602L53.678 44.6599L51.1858 43.8662L49.9473 46.6365Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M49.735 42.1973C49.735 42.1973 48.1123 44.3609 48.1123 44.7956C48.1123 45.2304 49.4115 46.6357 49.9524 46.6357C50.3063 46.6357 51.2314 45.9887 51.8228 45.5387C51.8949 45.4853 51.9557 45.4183 52.0019 45.3413C52.048 45.2644 52.0785 45.1791 52.0917 45.0904C52.1048 45.0016 52.1003 44.9112 52.0785 44.8242C52.0567 44.7372 52.0179 44.6553 51.9644 44.5833C51.3476 43.734 50.1293 42.1973 49.735 42.1973Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6929 45.5938L50.6391 43.1016",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5798 44.3457L49.3252 46.292",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6523 44.0743V50.7876L65.6139 49.271C66.2193 49.1868 66.7725 48.8824 67.1679 48.4162C67.5632 47.95 67.773 47.3545 67.7573 46.7434V45.7779C67.7509 45.444 67.6775 45.1147 67.5414 44.8097C67.4054 44.5047 67.2094 44.2302 66.9651 44.0025C66.7208 43.7747 66.4333 43.5984 66.1195 43.4839C65.8058 43.3695 65.4722 43.3192 65.1387 43.3362L52.6523 44.0743Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1717 53.613H38.3725C38.1372 53.6132 37.9109 53.5222 37.7413 53.3591C37.5716 53.196 37.4717 52.9736 37.4626 52.7384L37.0531 41.617C37.0497 41.4952 37.0707 41.3739 37.1149 41.2603C37.159 41.1467 37.2254 41.043 37.3102 40.9554C37.395 40.8678 37.4964 40.7981 37.6085 40.7502C37.7206 40.7024 37.8411 40.6774 37.963 40.6768H45.5761C45.6982 40.6767 45.8191 40.7012 45.9315 40.7488C46.0439 40.7964 46.1456 40.8662 46.2305 40.9539C46.3154 41.0416 46.3818 41.1456 46.4257 41.2595C46.4696 41.3734 46.4901 41.495 46.4861 41.617L46.0766 52.7384C46.0687 52.9731 45.9699 53.1956 45.8011 53.3588C45.6322 53.522 45.4065 53.6131 45.1717 53.613Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3523 46.4201L36.9507 45.5557L41.0706 45.6618C41.0706 45.6618 41.5003 46.4201 41.0706 46.5313C40.641 46.6425 38.7958 46.7487 38.7958 46.7487L41.288 47.2896C41.288 47.2896 41.288 48.0479 40.8533 48.0479C40.4185 48.0479 38.4672 49.2409 37.9263 49.6706C37.3854 50.1003 34.0288 49.4583 34.0288 49.4583L32.5122 49.3471V46.6375L34.3523 46.4201Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M33.379 46.0956V52.8139L23.4152 51.5148C22.8097 51.4295 22.2566 51.1251 21.8606 50.6592C21.4646 50.1934 21.2533 49.5984 21.2667 48.9872V48.0267C21.2731 47.6932 21.3463 47.3644 21.4821 47.0598C21.6179 46.7551 21.8134 46.4808 22.0571 46.2531C22.3008 46.0254 22.5878 45.849 22.9009 45.7342C23.2141 45.6194 23.5471 45.5687 23.8803 45.585L33.379 46.0956Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3655 63.5967H50.9009V65.2042H56.3655V63.5967Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1795 63.5967H33.7148V65.2042H39.1795V63.5967Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6323 114.731V79.0468C72.6326 78.0582 72.8438 77.081 73.2518 76.1805C73.6597 75.28 74.2551 74.4769 74.9981 73.8248L81.8125 67.8647C82.5429 67.2252 83.1282 66.4371 83.5292 65.553C83.9302 64.669 84.1378 63.7095 84.1379 62.7387V60.0747C84.1379 59.5836 84.0411 59.0974 83.853 58.6439C83.665 58.1903 83.3894 57.7782 83.0419 57.4313C82.6945 57.0843 82.2821 56.8092 81.8282 56.6218C81.3744 56.4343 80.8881 56.3382 80.3971 56.3389H30.9219C29.9311 56.3389 28.9809 56.7325 28.2803 57.4331C27.5797 58.1337 27.1861 59.0839 27.1861 60.0747V63.7093C27.1847 65.4418 26.5231 67.1085 25.3359 68.3702L19.2697 74.8055C18.0622 76.0932 17.3899 77.7921 17.3892 79.5574V114.731",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8916 93.5947V114.73",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6783 62.0654V63.7084C26.6769 65.4408 26.0153 67.1076 24.8281 68.3693L18.7619 74.8045C17.5544 76.0922 16.882 77.7911 16.8813 79.5564V90.4604",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5104 56.3389H30.4125C29.4218 56.3389 28.4715 56.7325 27.7709 57.4331C27.0703 58.1337 26.6768 59.0839 26.6768 60.0747",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1191 101.425V79.0454C72.1194 78.0568 72.3306 77.0796 72.7386 76.1791C73.1466 75.2786 73.7419 74.4755 74.485 73.8234L81.2994 67.8633C82.0297 67.2238 82.615 66.4357 83.016 65.5516C83.4171 64.6676 83.6246 63.7081 83.6248 62.7373V60.0732",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1191 114.73V104.145",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8931 107.824H9.91553V117.894H23.8931V107.824Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8931 118.177H9.91553V125.335H23.8931V118.177Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8819 118.177H64.9043V125.335H78.8819V118.177Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1084 130.852H12.7218L9.92627 125.342H23.9039L21.1084 130.852Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7607 125.538L13.5958 129.971",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3315 127.586L14.5135 128.097",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5957 125.538L14.081 126.898",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0914 130.852H67.6998L64.9043 125.342H78.8869L76.0914 130.852Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3765 125.538L68.2115 129.618",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2109 125.538L69.04 127.302",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9851 128.724L75.3633 129.972",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5755 125.538L76.3066 128.096",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8819 107.824H64.9043V117.894H78.8819V107.824Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1726 117.889H63.6426V123.5C63.6426 124.841 63.11 126.126 62.162 127.075C61.214 128.023 59.9282 128.555 58.5874 128.555H30.1773C28.8365 128.555 27.5507 128.023 26.6027 127.075C25.6547 126.126 25.1221 124.841 25.1221 123.5V117.889H25.1726Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8569 116.453H4.45312V122.782H85.8569V116.453Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 120.266H29.3853L36.4525 118.319H70.8733L72.5011 116.687",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/Data.4b08f256fdedf9c0ba5af2476ff0db9c.svg";
export { ForwardRef as ReactComponent };